module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-collection"
  }, [_c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._l((_vm.collectionList), function(collection) {
    return [_c('article', {
      staticClass: "media"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content max-lines--one-plus-three"
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(collection.name))]), _vm._v(" "), _c('small', [_vm._v("(" + _vm._s(collection.counts.items) + " items)")]), _vm._v(" "), _c('br'), _vm._v("\n                " + _vm._s(collection.description) + "\n                "), _c('br')])])]), _vm._v(" "), _c('div', {
      staticClass: "media-right"
    })])]
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "media-left"
  }, [_c('p', {
    staticClass: "image is-64x64"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/256x256"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-312241fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileCollections.vue
// module id = 279
// module chunks = 1